import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Injector, Input, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime, EMPTY, from, map, Observable, startWith, switchMap } from 'rxjs';
import { RequestService } from '../../../../../shared/services/request.service';
import { FormType } from '../../../../../shared/enum/form-type';
import { MapComponentService } from '../../../../../shared/map/map.component';
import { ComponentService } from '../../../../../shared/abstract/component.service';
import { SearchCustomModel } from '../../../../../shared/model/search-custom-model';
import { NominatimReverseRequestModel } from 'shared/model/nominatim-reverse-request-model';
import { AddressTypeEnum } from 'shared/enum/address-type-enum';
import { NominatimSearchRequestModel } from 'shared/model/nominatim-search-request-model';

@Component({
  selector: 'app-address-search',
  templateUrl: './address-search.component.html',
  styleUrl: './address-search.component.css',
})
export class AddressSearchComponent extends ComponentService<any> implements OnDestroy {
  currentRoute: any;
  searchAddressControl = new FormControl('', [
  ]);
  search = true;
  @Input("sendingFormType") formType: any;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  regex = /^[-+]?[0-9]*\.?[0-9]+\s*,\s*[-+]?[0-9]*\.?[0-9]+$/;

  constructor(
    injector: Injector,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private request: RequestService,
    private _map: MapComponentService,
    //private _service: Client,
    private _router: Router
  ) {
    super(injector);
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.currentRoute = this._router.url.split('/')
  }

  ngOnInit() {
    this.filteredOptions = this.searchAddressControl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(300),
        switchMap((value) => {
          if (value) {
            return this._filter(value)
          }
          return EMPTY
        }
        )
      );
  }

  inputClicked() {
    //reload filteredOptions 
    this.filteredOptions = this.searchAddressControl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(300),
        switchMap((value) => {
          if (value) {
            return this._filter(value)
          }
          return EMPTY
        }
        )
      );
  }

  private _filter(value: any): Observable<any[]> {
    if (typeof value === "string" && !this.regex.test(value)) {
      const model = new NominatimSearchRequestModel();
      const filterValue = value.toLowerCase();
      model.words = filterValue;
      model.addressType = this._appsService.addressRule ?? AddressTypeEnum.BMS;
      model.companyId = this._appsService.existCurrentProject?.companyId;
      model.projectId = this._appsService.existCurrentProject?.projectId;
      return from(this.request.search(model))
        .pipe(
          map(res => {
            var result = JSON.parse(res.data);
            this.addresses = result;
            return result;
          })
        );
    }
    else if (this.regex.test(value)) {
      if (value.length > 3) {
        var coord = value.replace(/,\s*/g, ',').split(",");
        if (coord.length > 1) {
          let reverseReq = new NominatimReverseRequestModel();
          reverseReq.lat = coord[0];
          reverseReq.lon = coord[1];
          reverseReq.max = 100;
          reverseReq.addressType = this._appsService.addressRule == AddressTypeEnum.OSM ? AddressTypeEnum.OSM : AddressTypeEnum.BMS;
          reverseReq.companyId = this._appsService.existCurrentProject?.companyId;
          reverseReq.projectId = this._appsService.existCurrentProject?.projectId;
          this.request.reverseGeocodeNominatim(reverseReq).then(_ => {
            if (_) {
              let value: any[] = [];
              let msg = 'Adres alınamadı';
              let data = typeof _.data === 'string' ? JSON.parse(_.data) : _.data;
              if (reverseReq.addressType === 1 && data.Ulke_Adi === 'Türkiye') {
                value = [
                  `${data.Yol_Adi || ''} ${data.Mahalle_Adi || data.BKBMahalle_Adi || ''} ${data.Ilce_Adi} ${data.Il_Adi}`,
                  "",
                  "",
                  data.Yol_Adi || null,
                  data.Mahalle_Adi || data.BKBMahalle_Adi || null,
                  data.Ilce_Adi || null,
                  data.Il_Adi || null,
                  coord[1],
                  coord[0],
                  data.Il_ID || 0,
                  data.Ilce_ID || 0,
                  data.Mahalle_ID || data.BKBMahalle_ID || 0,
                  "",
                  "",
                  ""
                ];
                var wkt = JSON.parse(JSON.stringify(value));
                var switchWkt = wkt[7];
                wkt[7] = wkt[8];
                wkt[8] = switchWkt;
                value = JSON.parse(JSON.stringify(wkt));
                this.search = false;
                if (this.formType != FormType.Team) {
                  value ? (this.formType == FormType.Region ? this._map.addRegionalWork([value[7], value[8]], 'create', value, this.formType) : this._map.addPointMarker([value[7], value[8]], 'create', value, this.formType)) : true;
                  //filteredOptions need to be cleared after operations due to unwanted display issue
                  //this.filteredOptions = EMPTY;
                  //this.searchAddressControl.setValue('');
                }

              }
              else if (reverseReq.addressType === 2 && data.address) {
                value = [
                  data.display_name,
                  "",
                  "",
                  null,
                  null,
                  null,
                  data.address.country || null,
                  coord[1],
                  coord[0],
                  0,
                  0,
                  0,
                  "",
                  "",
                  ""
                ];
                var wkt = JSON.parse(JSON.stringify(value));
                var switchWkt = wkt[7];
                wkt[7] = wkt[8];
                wkt[8] = switchWkt;
                value = JSON.parse(JSON.stringify(wkt));
                this.search = false;
                if (this.formType != FormType.Team) {
                  value ? (this.formType == FormType.Region ? this._map.addRegionalWork([value[7], value[8]], 'create', value, this.formType) : this._map.addPointMarker([value[7], value[8]], 'create', value, this.formType)) : true;
                  //filteredOptions need to be cleared after operations due to unwanted display issue
                  //this.filteredOptions = EMPTY;
                  //this.searchAddressControl.setValue('');
                }
              }
            }
          }
          );
        }
      } else {
        this.MessageBox('Adres verisi boş geldi', 'orange', 'center');
      }
      return this.filteredOptions;
    }
    else {
      var wkt = JSON.parse(JSON.stringify(value));
      var switchWkt = wkt[7];
      wkt[7] = wkt[8];
      wkt[8] = switchWkt;
      value = JSON.parse(JSON.stringify(wkt));
      this.search = false;
      if (this.formType != FormType.Team) {
        value ? (this.formType == FormType.Region ? this._map.addRegionalWork([value[7], value[8]], 'create', value, this.formType) : this._map.addPointMarker([value[7], value[8]], 'create', value, this.formType)) : true;
        //filteredOptions need to be cleared after operations due to unwanted display issue
        //this.filteredOptions = EMPTY;
        //this.searchAddressControl.setValue('');
      }
      else {
        this.MessageBox(this.languageKey("whileTeamSelected"), "orange", "center");
      }
      return this.filteredOptions;
    }
  }



  ngOnDestroy() {

  }


  /* Auto Complete */
  isAutoSelected = false;
  filteredOptions!: Observable<any[]>;
  addresses: string[] = [];


  displayFn(address: string[]): string {
    return address ? address[0] : '';
  }

  clearSearch() {
    if (!this.search) {
      this.search = true;
      this.searchAddressControl.setValue('');
      //this._mapService.currentLayerGroup.clearLayers();
      //this._mapService.currentLayerGroupv2 ? this._mapService.currentLayerGroupv2.clearLayers() : null;
      //this._mapService.startingBounds();
    }
  }




}
